<template>
    <v-container fluid>
        <v-card>
            <v-card-title class="text-subtitle-1 font-weight-bold">
                <v-icon left color="primary">smart_display</v-icon>
                Video tutorial para los participantes
            </v-card-title>
            <v-card-text>
                <p class="text-body-2 grey--text text--darken-1">
                    En la pantalla donde ingresan los participantes aparece un botón que abre este video, para quien
                    no sepa cómo descargar su certificado. Pegue aquí el enlace del video de YouTube.
                </p>

                <v-form ref="form" v-model="valido" @submit.prevent>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="modelo.tutorial_url"
                                label="Enlace del video en YouTube"
                                placeholder="https://www.youtube.com/watch?v=..."
                                outlined dense clearable
                                prepend-inner-icon="link"
                                :rules="[(v) => !v || !!videoId || 'No parece un enlace de un video de YouTube']"
                                hint="Copie la dirección desde el botón Compartir del video."
                                persistent-hint
                            />

                            <v-text-field
                                class="mt-4"
                                v-model="modelo.tutorial_titulo"
                                label="Texto del botón"
                                outlined dense counter="80" maxlength="80"
                                prepend-inner-icon="title"
                            />

                            <v-switch
                                v-model="modelo.tutorial_activo"
                                :disabled="!videoId"
                                :label="modelo.tutorial_activo ? 'Se muestra en el ingreso de participantes' : 'No se muestra'"
                                color="success" inset hide-details class="mt-1"
                            />

                            <v-btn color="primary" small class="mt-5" :loading="guardando" @click="guardar">
                                <v-icon small left>save</v-icon> Guardar
                            </v-btn>
                        </v-col>

                        <v-col cols="12" md="6">
                            <div class="text-caption font-weight-bold grey--text text--darken-2 mb-1">Vista previa</div>
                            <div class="previa">
                                <iframe
                                    v-if="videoId"
                                    :key="videoId"
                                    :src="`https://www.youtube-nocookie.com/embed/${videoId}?rel=0`"
                                    title="Vista previa del tutorial"
                                    frameborder="0" allowfullscreen
                                ></iframe>
                                <div v-else class="previa__vacia">
                                    <v-icon large color="grey lighten-1">smart_display</v-icon>
                                    <span>Pegue el enlace para ver aquí el video</span>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import Auth from "@/services/auth";

const PATRONES = [
    /^https?:\/\/(?:www\.|m\.)?youtube\.com\/watch\?(?:.*&)?v=([A-Za-z0-9_-]{11})/,
    /^https?:\/\/youtu\.be\/([A-Za-z0-9_-]{11})/,
    /^https?:\/\/(?:www\.)?youtube(?:-nocookie)?\.com\/(?:embed|shorts|live)\/([A-Za-z0-9_-]{11})/,
];

export default {
    name: "AdministracionCentroAyuda",
    data() {
        return {
            valido: true,
            guardando: false,
            modelo: {tutorial_url: "", tutorial_titulo: "", tutorial_activo: false},
        }
    },
    computed: {
        // Mismas formas de enlace que acepta el servidor.
        videoId() {
            const url = (this.modelo.tutorial_url || "").trim();
            for (const patron of PATRONES) {
                const partes = url.match(patron);
                if (partes) return partes[1];
            }
            return null;
        },
    },
    watch: {
        videoId(id) {
            if (!id) this.modelo.tutorial_activo = false;
        },
    },
    methods: {
        cargar() {
            window.axios.get("/ayuda/ajustes").then(response => {
                if (response.data.success) {
                    const d = response.data.data;
                    this.modelo = {tutorial_url: d.tutorial_url || "", tutorial_titulo: d.tutorial_titulo || "", tutorial_activo: !!d.tutorial_activo};
                } else {
                    this.$toast.error(response.data.message);
                }
            }).catch(() => this.$toast.error("No se pudo cargar el centro de ayuda."));
        },
        guardar() {
            if (!this.$refs.form.validate()) return;

            this.guardando = true;
            const datos = {
                tutorial_url: (this.modelo.tutorial_url || "").trim(),
                tutorial_titulo: (this.modelo.tutorial_titulo || "").trim(),
                tutorial_activo: this.modelo.tutorial_activo ? 1 : 0,
            };

            window.axios.post("/ayuda/ajustes", datos).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message, {timeout: 8000});
                } else {
                    this.$toast.error(response.data.message, {timeout: 10000});
                }
            })
                .catch(() => this.$toast.error("No se pudo guardar."))
                .finally(() => {
                    this.guardando = false;
                });
        },
    },
    created() {
        Auth.checkPermisos("/administracion/centro_ayuda").then(() => this.cargar());
    },
}
</script>

<style scoped>
.previa {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    background: #0e1326;
    border-radius: 8px;
    overflow: hidden;
}

.previa iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}

.previa__vacia {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #aab1c6;
    font-size: 0.85rem;
}
</style>
